import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const CheckCircle = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12C2 6.49 6.49 2 12 2C17.51 2 22 6.49 22 12C22 17.51 17.51 22 12 22C6.49 22 2 17.51 2 12ZM3.25 12C3.25 16.82 7.17 20.75 12 20.75C16.83 20.75 20.75 16.82 20.75 12C20.75 7.18 16.83 3.25 12 3.25C7.17 3.25 3.25 7.18 3.25 12ZM9.9101 15.64L16.5101 7.30998V7.29998C16.7201 7.02998 17.1201 6.98998 17.3901 7.19998C17.6601 7.41998 17.7001 7.80998 17.4901 8.07998L10.9401 16.36C10.8501 16.48 10.7301 16.6 10.5901 16.69C10.3401 16.85 10.0501 16.94 9.7601 16.94C9.6701 16.94 9.5701 16.93 9.4701 16.91C9.0801 16.83 8.7401 16.6 8.5201 16.27L6.4901 13.38C6.2901 13.1 6.3601 12.71 6.6401 12.51C6.9201 12.31 7.3101 12.38 7.5101 12.66L9.5501 15.56C9.6101 15.65 9.6801 15.68 9.7201 15.68C9.72526 15.68 9.7311 15.6802 9.73749 15.6803C9.7806 15.6816 9.84914 15.6835 9.9101 15.64Z"
    />
  </svg>
)

export default withDefaultStyles(CheckCircle)
